<template>
  <v-layout class="about-page" column>
    <v-img
      :src="require('@/assets/background.png')"
      :height="$vuetify.breakpoint.mdAndUp ? '80vh' : '100%'"
      width="100%"
    >
      <v-row
        class="fill-height"
        align="center"
        justify="space-between"
        no-gutters
      >
        <div class="content">
          <div class="content-title">Olá,</div>
          <div class="content-title">eu sou o Júlio.</div>
          <br />
          <div class="content-description">
            Desenvolvedor de software com experiência em Vue.js, apaixonado por
            criar interfaces dinâmicas e funcionais.
          </div>
        </div>
      </v-row>
    </v-img>
  </v-layout>
</template>

<script>
export default {
  name: "AboutPage",

  components: {},
};
</script>

<style src="./style.scss" lang="scss" scoped />
